// F1 App-Shell (TES-948): Produktionsmodus-Flag (DevTools-Sichtbarkeit).
// Aus useShellModel/AppLayout ausgelagert. null = noch nicht ermittelt.
import { useState, useEffect } from "react";
import { isProductionMode } from "@/lib/environment";
import { logger } from "@/lib/logger";

export function useProductionMode(): boolean | null {
  const [isInProductionMode, setIsInProductionMode] = useState<boolean | null>(null);

  useEffect(() => {
    const check = async () => {
      try {
        setIsInProductionMode(await isProductionMode());
      } catch (error) {
        logger.error("Failed to check production mode", error);
        setIsInProductionMode(false);
      }
    };
    check();
  }, []);

  return isInProductionMode;
}
